import PropTypes from 'prop-types';
import React from 'react';
import ResponseBox from './ResponseBox';
import {
    RESPONSE_GAP,
    ESCAPE_QUOTE,
    MAZE_ITALIC_START,
    MAZE_ITALIC_END,
} from '../../constants/regExp';

// TODO maybe refactor this somewhere in the future

const ClozeText = props => {
    const getResponseOptions = questionIndexStr => {
        const questionIndex = parseInt(questionIndexStr, 10);
        const question = props.questions[questionIndex];
        return (
            <ResponseBox
                isTabIndexActive={props.isTabIndexActive}
                questionId={question.id}
                key={question.id}
                options={question.possibleResponses}
                selectedId={props.selectedResponses[question.id]}
                onResponseSelected={props.onResponseSelected}
            />
        );
    };
    const getParsedHTML = snippet => {
        // TODO replace this implementation with non-dangerous way
        // eslint-disable-next-line react/no-danger
        return <span dangerouslySetInnerHTML={{ __html: snippet }} />;
    };
    const paragraphWithGaps = props.text
        .replace(ESCAPE_QUOTE, '"')
        .replace(MAZE_ITALIC_START, '<i>')
        .replace(MAZE_ITALIC_END, '</i>')
        .split(RESPONSE_GAP)
        .map((snippet, i) => {
            // placeholder numbers a 2-digit, hence we have 'len > 2' condition
            // to exclude text pieces with legit numbers - they will have greater length (e.g. ' 1 ' or ' 20 ')
            if (snippet.length === 0 || snippet.length > 2 || Number.isNaN(+snippet)) {
                return <span key={`text-${i}`}>{getParsedHTML(snippet)}</span>;
            }
            return getResponseOptions(snippet);
        });
    return <div>{paragraphWithGaps}</div>;
};

export default ClozeText;

ClozeText.propTypes = {
    questions: PropTypes.arrayOf(PropTypes.object).isRequired,
    text: PropTypes.string.isRequired,
    selectedResponses: PropTypes.object,
    onResponseSelected: PropTypes.func,
    isTabIndexActive: PropTypes.bool,
};

ClozeText.defaultProps = {
    selectedResponses: {},
    onResponseSelected: () => {},
    isTabIndexActive: true,
};
